import { inject, Pipe, PipeTransform } from '@angular/core';

import { ReferentielStore } from '../../administration/gestion-référentiels/store/referentiel.store';

@Pipe({
  name: 'convertIdReferentielToNom',
})
export class ConvertIdReferentielToNomPipe implements PipeTransform {
  readonly #référentielStore = inject(ReferentielStore);

  transform(value: string): string {
    return this.#référentielStore.entityMap()[value]?.nom ?? 'Non trouvé';
  }
}
